<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-header">
          <div>
            <h3 class="card-title">{{ "UPDATE_RESIDUAL_ABSENCES" | translate }}</h3>
            <p class="mt-025 text-primary" *ngIf="errorFiscalCode">{{ "ERROR_FISCAL_CODE_NUMBERS" | translate }} {{ fiscal_code_to_check }}</p>
            <p class="mt-025 text-primary" *ngIf="errorPermission || errorHolidays">{{ "ERROR_ABSENCES_NUMBERS" | translate }} {{ fiscal_code_to_check }}</p>
          </div>
          <div *ngIf="xlsx_file_content">
            <a class="btn btn-outline-secondary text-secondary mr-2" (click)="xlsx_file_content = null; fileName = null; errorHolidays = false; errorPermission = false; errorFiscalCode = false">
              {{ "RESET" | translate }}
            </a>
            <button class="btn btn-outline-primary text-primary" [disabled]="errorHolidays || errorPermission || errorFiscalCode" (click)="save()">{{ "IMPORT" | translate }}</button>
          </div>
        </div>
        <div class="card-body" *ngIf="!xlsx_file_content">
          <div class="row">
            <div class="col-md-4">
              <fieldset>
                <div class="custom-file">
                  <input class="custom-file-input" type="file" lang="it" id="file" accept="application/vnd.sealed.xls" (change)="handlerChangeFileInput($event)" />
                  <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                  <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pb-0" *ngIf="xlsx_file_content">
          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [rows]="xlsx_file_content" [headerHeight]="50" [scrollbarV]="false" [scrollbarH]="true" [rowHeight]="60" [limit]="20" [footerHeight]="50">
            <ngx-datatable-column *ngFor="let key of columnKey" [name]="key.toUpperCase() | translate" [prop]="key" [sortable]="true" [width]="null">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row[key] || 0 }}
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
